<template>
  <hic-list-page title="班次管理" :entities="entities" :condition="condition" @ok="page" @load="page" :loading="loading" ref="listPage">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small">
        <i class="el-icon-plus"></i>
        新建班次
      </el-button>
    </template>
    <el-table-column label="操作" width="120" align="center" fixed="left">
      <template slot-scope="scope">
        <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row)" />
        <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row)" :seconds="3" size="mini" class="left-pad" />
      </template>
    </el-table-column>
    <el-table-column label="班次名称" prop="name" min-width="120" align="center"></el-table-column>
    <el-table-column label="颜色标识" prop="color" min-width="100" align="center">
      <template slot-scope="{ row }">
        <div :style="{ backgroundColor: row.color, width: '30px', height: '20px', display: 'inline-block', border: '1px solid #ccc', borderRadius: '4px' }"></div>
        <span style="margin-left:8px;">{{ row.color }}</span>
      </template>
    </el-table-column>
    <el-table-column label="工作量(天)" prop="workload" width="100" align="center"></el-table-column>
    <el-table-column label="是否禁用" prop="disabled" width="100" align="center">
      <template slot-scope="{ row }">
        <el-tag :type="row.disabled ? 'danger' : 'success'" size="small">{{ row.disabled ? '禁用' : '启用' }}</el-tag>
      </template>
    </el-table-column>
    
    <shift-type-edit :visible.sync="showEditor" :entity="currentEntity" @ok="page" />
  </hic-list-page>
</template>

<script>
import api from '@/common/api'

export default {
  name: 'shiftTypeView',
  components: {
    'shift-type-edit': () => import('./edit')
  },
  data() {
    return {
      loading: false,
      showEditor: false,
      entities: { items: [], total: 0, index: 1 },
      condition: {
        pageIndexOnView: 1,
        pageSize: 20
      },
      currentEntity: {}
    }
  },
  methods: {
    page() {
      this.loading = true
      api.ShiftType.query(this.condition).then(res => {
        this.entities = res
      }).catch(err => {
        this.$message.error('加载失败: ' + err)
      }).finally(() => {
        this.loading = false
      })
    },
    create() {
      this.currentEntity = {
        id: null,
        name: '',
        color: '#ffffff',
        disabled: false,
        workload: 1
      }
      this.showEditor = true
    },
    edit(row) {
      this.currentEntity = this.$utils.Obj.clone(row)
      this.showEditor = true
    },
    del(row) {
      api.ShiftType.del(row.id).then(() => {
        this.$message.success('删除成功')
        this.page()
      }).catch(err => {
        this.$message.error('删除失败: ' + err)
      })
    }
  }
}
</script>
